import { supabase } from "@/integrations/supabase/client";
import type { AffirmationBackdrop } from "@/types";

const LEGACY_BACKGROUND_KEY = "universe-chat-background";
const BACKGROUND_KEY_PREFIX = "universe-chat-background";
const GENERATED_KEY_PREFIX = "universe-chat-generated-backdrop";

async function getUserStorageKey(prefix: string): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  const userId = data.session?.user.id;
  return userId ? `${prefix}:${userId}` : null;
}

export async function loadSelectedChatBackground(): Promise<string | null> {
  const key = await getUserStorageKey(BACKGROUND_KEY_PREFIX);
  if (!key) return null;

  const saved = localStorage.getItem(key);
  if (saved) return saved;

  const legacy = localStorage.getItem(LEGACY_BACKGROUND_KEY);
  if (legacy) {
    localStorage.setItem(key, legacy);
    localStorage.removeItem(LEGACY_BACKGROUND_KEY);
    return legacy;
  }

  return null;
}

export async function saveSelectedChatBackground(url: string | null): Promise<void> {
  const key = await getUserStorageKey(BACKGROUND_KEY_PREFIX);
  if (!key) return;

  if (url) localStorage.setItem(key, url);
  else localStorage.removeItem(key);
}

export async function loadGeneratedChatBackdrop(): Promise<AffirmationBackdrop | undefined> {
  const key = await getUserStorageKey(GENERATED_KEY_PREFIX);
  if (!key) return undefined;

  const saved = localStorage.getItem(key);
  if (!saved) return undefined;

  try {
    return JSON.parse(saved) as AffirmationBackdrop;
  } catch {
    localStorage.removeItem(key);
    return undefined;
  }
}

export async function saveGeneratedChatBackdrop(backdrop: AffirmationBackdrop | undefined): Promise<void> {
  const key = await getUserStorageKey(GENERATED_KEY_PREFIX);
  if (!key) return;

  if (backdrop) localStorage.setItem(key, JSON.stringify(backdrop));
  else localStorage.removeItem(key);
}